import React from 'react'
import {useAppSelector} from 'store'
import {isStart} from 'store/secretword/selectors'
import {StartPage} from 'src/common/components/StartPage'
import {GamePage} from 'src/common/components/GamePage'
import {GallowGameLayout} from 'src/layouts/GallowGameLayout/GallowGameLayout'

export const GallowGamePage: React.FC = () => {
  const isShowStartPage = useAppSelector(isStart)

  return (
    <GallowGameLayout>
      {isShowStartPage
        ? <StartPage />
        : <GamePage />
      }
    </GallowGameLayout>
  )
}
